export default {
  title: 'Performances hebdomadaires',
  messages_sent: 'Messages envoyés',
  messages_delivered: 'Messages livrés',
  click_rate: 'Taux de clics moyen',
  awaiting: 'En attente de confirmation',
  legend: {
    sent: 'Envoyé',
    clicked: 'Cliqué',
    delivered: 'Livré',
  },
  error_messages: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
